export function getText(payment) {
  return `with ${payment.type_info === 'ACH' ? 'bank account' : 'credit card'}${payment.last_four_digits ? ` XXXX ${payment.last_four_digits}` : ''}${payment.payer_name ? ` (${payment.payer_name})` : ''}`
}
